"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var styles = function styles(theme) {
  return {
    '@keyframes fade': {
      from: {
        opacity: 0
      },
      to: {
        opacity: 1
      }
    },
    root: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center'
    },
    description: {
      opacity: 0,
      marginTop: theme.spacing(2),
      animation: '$fade 1s linear forwards'
    }
  };
};

var _default = styles;
exports.default = _default;